module.exports = __webpack_public_path__ + "static/media/whatsappBroadcast.a5d6fe6f.svg";